// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demo-ruleForm[data-v-676930b3]  .el-form-item .el-form-item__content{display:flex;justify-content:space-between}.demo-ruleForm[data-v-676930b3]  .el-form-item .el-form-item__content .el-button{margin-left:10px;width:180px}", ""]);
// Exports
module.exports = exports;
